var React = require('react');

function Quidditch (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M494.5 351.82a79.9 79.9 0 1 0 79.8 79.9 79.91 79.91 0 0 0-79.8-79.9zM636.5 31L616.7 6a16 16 0 0 0-22.4-2.6L361.8 181.32l39.7 50.1L634 53.52A16 16 0 0 0 636.5 31z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M93.2 257.72c-21.9 17.5-40.2 55.8-54.6 97.5l60.4-22.1a6 6 0 0 1 6.6 9.5L11 454.82c-7.2 32.3-11 55.4-11 55.4s206.7 13.6 266.6-34.1S343.2 326 343.2 326l-86.7-109.2s-103.4-6.88-163.3 40.92zm342.4 16.6l-107.9-136a11 11 0 0 0-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4a11 11 0 0 0 6.3-17.6z","className":"fa-primary","key":2})]);
}

Quidditch.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Quidditch;

Quidditch.default = Quidditch;
